import { CardImagePizza } from "components/card/card_image/card_image_pizza/card_image_pizza";
import { CardHolder } from "components/card_holder/card_holder";
import { DropDownMenu } from "components/dropdown_menu/dropdown_menu";
import { Footer } from "components/footer/footer";
import { LabelButtons } from "components/label/label_buttons/label_buttons";
import { LabelHolder } from "components/label_holder/label_holder";
import { NavigationBarHeader } from "components/navbar/navbar_pizza";
import { Loading } from "pages/loading/loading";
import { useState } from "react";
import { filterPizzasCreme } from "utils/filters/filterPizzasCreme";
import { filterPizzasTomate } from "utils/filters/filterPizzasTomate";
import Transitions from "utils/transition";
import "./pizzas.css";
import { useStrapi } from "hooks/use-strapi";

import { CardTitleText } from "components/card/card_title_text/card_title_text";
import { CardWideImageTilteText } from "components/card/card_wide_image_title_text/card_wide_image_title_text";

export function Pizzas() {
  const [isCremeActive, onCremeUpdate] = useState(false);
  const [isTomateActive, onTomateUpdate] = useState(false);
  const [isBasiqueActive, onBasiqueUpdate] = useState(false);
  const [isClassiqueActive, onClassiqueUpdate] = useState(false);
  const [isGourmandeActive, onGourmandeUpdate] = useState(false);

  const { data: personnalisation, loading: loadingPersonnalisation } =
    useStrapi("cg-personnalisation");
  const { data: pizzaBasique, loading: loadingPizzaBasique } =
    useStrapi("cg-pizza-basiques");
  const { data: pizzaClassique, loading: loadingPizzaClassique } = useStrapi(
    "cg-pizza-classiques",
  );
  const { data: pizzaGourmande, loading: loadingPizzaGourmande } = useStrapi(
    "cg-pizza-gourmandes",
  );
  const { data: supplements, loading: loadingSupplements } =
    useStrapi("cg-supplements");
  const { data: etablissement, loading: loadingEtablissement } =
    useStrapi("cg-etablissement");

  if (
    loadingEtablissement ||
    loadingPizzaBasique ||
    loadingPizzaClassique ||
    loadingPizzaGourmande ||
    loadingSupplements ||
    loadingPersonnalisation
  ) {
    return <Loading />;
  }

  let pizzaBasiqueFiltered = [];
  let pizzaClassiqueFiltered = [];
  let pizzaGourmandeFiltered = [];

  if (isCremeActive) {
    pizzaBasiqueFiltered = filterPizzasCreme(pizzaBasique);
    pizzaClassiqueFiltered = filterPizzasCreme(pizzaClassique);
    pizzaGourmandeFiltered = filterPizzasCreme(pizzaGourmande);
  }
  if (isTomateActive) {
    pizzaBasiqueFiltered = filterPizzasTomate(pizzaBasique);
    pizzaClassiqueFiltered = filterPizzasTomate(pizzaClassique);
    pizzaGourmandeFiltered = filterPizzasTomate(pizzaGourmande);
  }

  if (pizzaBasiqueFiltered.length === 0) {
    pizzaBasiqueFiltered = pizzaBasique;
  }
  if (pizzaClassiqueFiltered.length === 0) {
    pizzaClassiqueFiltered = pizzaClassique;
  }
  if (pizzaGourmandeFiltered.length === 0) {
    pizzaGourmandeFiltered = pizzaGourmande;
  }

  function onClickCreme() {
    onCremeUpdate(!isCremeActive);
    onTomateUpdate(false);
  }

  function onClickTomate() {
    onTomateUpdate(!isTomateActive);
    onCremeUpdate(false);
  }

  function onClickBasique() {
    onBasiqueUpdate(!isBasiqueActive);
  }

  function onClickClassique() {
    onClassiqueUpdate(!isClassiqueActive);
  }

  function onClickGourmande() {
    onGourmandeUpdate(!isGourmandeActive);
  }

  return (
    <>
      <Transitions className="transition">
        <NavigationBarHeader />
        <LabelHolder>
          <LabelButtons>
            <button
              id="creme_button"
              onClick={onClickCreme}
              className={isCremeActive ? "active" : "inactive"}
            >
              Crème
            </button>
            <button
              id="tomate_button"
              onClick={onClickTomate}
              className={isTomateActive ? "active" : "inactive"}
            >
              Tomate
            </button>
          </LabelButtons>
          <p>
            *Les bases crème ou tomate sont des suggestions il est possible de
            les changer à votre convenance
          </p>
        </LabelHolder>

        <CardHolder>
          <DropDownMenu title="Pizzas Basiques" callback={onClickBasique}>
            <CardHolder
              className={
                isBasiqueActive ? "dropdown_active" : "dropdown_inactive"
              }
            >
              {pizzaBasiqueFiltered.map((value) => {
                return (
                  <CardImagePizza data={value} key={value.id}></CardImagePizza>
                );
              })}
            </CardHolder>
          </DropDownMenu>
          <DropDownMenu title="Pizzas Classiques" callback={onClickClassique}>
            <CardHolder
              className={
                isClassiqueActive ? "dropdown_active" : "dropdown_inactive"
              }
            >
              {pizzaClassiqueFiltered.map((value) => {
                return (
                  <CardImagePizza data={value} key={value.id}></CardImagePizza>
                );
              })}
            </CardHolder>
          </DropDownMenu>
          <DropDownMenu title="Pizzas Gourmandes" callback={onClickGourmande}>
            <CardHolder
              className={
                isGourmandeActive ? "dropdown_active" : "dropdown_inactive"
              }
            >
              {pizzaGourmandeFiltered.map((value) => {
                return (
                  <CardImagePizza data={value} key={value.id}></CardImagePizza>
                );
              })}
            </CardHolder>
          </DropDownMenu>
        </CardHolder>

        <CardHolder>
          <CardWideImageTilteText
            title={personnalisation.Titre}
            description={personnalisation.Description}
            src={personnalisation.Photo}
          ></CardWideImageTilteText>
          <CardTitleText title="Suppléments">
            {supplements.map((value) => {
              return (
                <div key={value.id} className="content">
                  <p>{value.Nom}</p>
                  <p className="price">{value.Prix + " €"}</p>
                </div>
              );
            })}
          </CardTitleText>
        </CardHolder>

        <Footer
          adress={etablissement.Adresse}
          contact={etablissement.Telephone}
        />
      </Transitions>
    </>
  );
}
